import React, { Component } from 'react';
import { Box } from "@mui/material";
import styled from 'styled-components';

import Editor from './Editor';
import './Submission.css';

const H3 = styled.h3`
  font-size: 16px;
  margin: 0;
  text-align: left;
`;

export default class Submission extends Component {

  locale = Intl.NumberFormat().resolvedOptions().locale;

  editorRef = React.createRef(null);

  getDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return `${date.toLocaleDateString(this.locale, {dateStyle:'medium'})} ${date.toLocaleTimeString(this.locale, {timeStyle:'short'})}`;
  }

  render() {
    const s = this.props.submission;

    return (<Box sx={{ ml:'1rem', textAlign: 'left' }}>
      <div className="submission-profile">
        <ul>
          <li><span className="submission-name">Submission Time</span><span className="submission-value">{this.getDate(s.created_on)}</span></li>
          <li><span className="submission-name">Status</span><span className="submission-value">{s.status || '--'}</span></li>
          <li><span className="submission-name">Candidate Email</span><span className="submission-value">{s.candidate_email || '--'}</span></li>
          <br/>
          <li><span className="submission-name">Email Subject</span><span className="submission-value">{s.subject || '--'}</span></li>
        </ul>

        <H3>Email Body</H3>
        <Editor
            placeholder="Empty"
            value={s.body}
            disabled={true}
          />

      </div>
    </Box>);
  }
}

